import React, {useEffect} from 'react';
import s from './styles.module.css'
import {Box, Button, Modal} from "@mui/material";
import classNames from "classnames";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Row from "../row";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    p: 4,
    borderRadius: '3px',
    maxWidth: '90%',
    width: '100%',
    maxHeight: '90vh',
    overflow: 'auto'
};

const ModalElement = ({open, onClose, data, setPage, confirm, subDataStatus, statusColored, status}) => {
    const total = data.reduce((acc, curr) => {
        return acc += +curr.value
    }, 0)

    return (
        <Modal
            open={open}
            // onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                {status === 'wait' ?
                    <h1 className={s.title}>Ожидайте перехода на следующую команду</h1> : <h1 className={s.title}>Подтвердите ввод оценок</h1>}

                <div className={s.content}>
                    {data.map((el, i) => <Row
                        isFirstElement={i === 0}
                        isHidden={true}
                        statusColored={statusColored}
                        row1_name={i === 0 && subDataStatus && subDataStatus?.techcontrol_other?.length > 0 && subDataStatus?.techcontrol_other[0]?.techcontrol_name}
                        row2_name={i === 0 && subDataStatus && subDataStatus?.techcontrol_other?.length > 0 && subDataStatus?.techcontrol_other[1]?.techcontrol_name}
                        row1={subDataStatus && subDataStatus?.techcontrol_other?.length > 0 && subDataStatus?.techcontrol_other[0]?.elements[i]}
                        row2={subDataStatus && subDataStatus?.techcontrol_other?.length > 0 && subDataStatus?.techcontrol_other[1]?.elements[i]}
                        type={Number(el.value)}
                        key={el.id} handlerClick={() => {
                    }} {...el}/>)}

                </div>

                <div className={s.btns} style={{display: status === 'wait' ? 'none' : 'flex'}}>
                    <Button variant="outlined" color="error" onClick={onClose}>
                        <CloseIcon sx={{fontSize: 40}}/>
                    </Button>
                    <Button variant="contained" onClick={confirm} sx={{
                        marginLeft: '100px'
                    }}>
                        <CheckIcon sx={{fontSize: 40}}/>
                    </Button>
                </div>
            </Box>
        </Modal>
    );
};

export default ModalElement;
